import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { CodaltComponent } from 'src/app/codalt.component';
import { EntitiesService } from 'src/app/services/entities/entities.service';
import { EntityType, EntityTypeCode } from 'src/app/services/entities/entity-type.class';
import { LocalStorage } from 'src/app/storage.class';

@Component({
    selector: 'app-planning-filter',
    templateUrl: './planning-filter.component.html',
    styleUrls: ['./planning-filter.component.scss'],
    standalone: false,
})
export class PlanningFilterComponent extends CodaltComponent implements OnInit {
    @Input() mobile = false;

    @Output()
    public selectedTeams = new EventEmitter<string[]>();

    entityTypes: EntityType[];

    fcTeams = new FormControl(LocalStorage.PlanningFilter ?? [EntityTypeCode.AsfaltTeam]);

    constructor(private entitiesService: EntitiesService) {
        super();
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.entitiesService.getTypes().subscribe(types => {
                this.entityTypes = types.data.filter(t => t.is_team);
            })
        );

        this.fcTeams.valueChanges.pipe(debounceTime(200)).subscribe(() => {
            LocalStorage.PlanningFilter = this.fcTeams.value;
            this.selectedTeams.emit(this.fcTeams.value);
        });
        this.selectedTeams.emit(this.fcTeams.value);
    }
}
